import { MasterdataAService } from '../../services';
import { EmployeesService } from '../../services/employees.service';

export const skillsState: aboTheme.IState = {

  parent: 'app',
  name: "skills",
  url: "/skills",
  redirectTo: "skills.dashboard",
  component: 'skillsComponent',
  data: {
    permissions: {
        only: ['EMPLOYEE']
    }
  }
};

export const skillsDashboardState: aboTheme.IState = {

    name: "skills.dashboard",
    url: "/skillsDashboard",
    resolve: { 
        employeeSkills: (EmployeeSkillsService: EmployeesService) => {
            "ngInject";
            return EmployeeSkillsService.all();
        }
    },
    views: {
        "main": 'skillsDashboardComponent'
    }
};

export const employeeSkillsItemState: aboTheme.IState = {

  name: "skills.dashboard.skill",
  url: "/employeeSkill/:employeeSkillId",
  params: {
    "employeeSkillId": null
  },
  modal: ['employeeSkills'],
  resolve: {
    skills: (MasterdataAService:MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Skills');
    }
  },
  component: 'skillsItemComponent'

};


// WEBPACK FOOTER //
// ./src/app/modules/skills/skills.states.ts